import { render, staticRenderFns } from "./PidSearchResults.vue?vue&type=template&id=5b003fc8&scoped=true&"
import script from "./PidSearchResults.vue?vue&type=script&lang=js&"
export * from "./PidSearchResults.vue?vue&type=script&lang=js&"
import style0 from "./PidSearchResults.vue?vue&type=style&index=0&id=5b003fc8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b003fc8",
  null
  
)

export default component.exports